"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJudgeStencil = exports.judgeStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.judgeStencilDefinition = {
    view: {
        label: 'Judge',
        category: 'person',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'subheading',
                    'title',
                    'bio',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: [
                            'first-name',
                            'surname',
                            'participating-disciplines',
                        ],
                    },
                    {
                        name: 'Social links',
                        items: ['social-links', 'website'],
                    },
                    {
                        name: 'Partners',
                        items: ['partner-profiles'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                ],
            },
        ],
        previewConfiguration: { hasPagePreview: true },
    },
    content: {
        [properties_1.bioPropertyDefinition.name]: properties_1.bioPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.firstNamePropertyDefinition.name]: properties_1.firstNamePropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.participatingDisciplinesPropertyDefinition.name]: {
            ...properties_1.participatingDisciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
            ],
        },
        [properties_1.partnerProfilesPropertyDefinition.name]: properties_1.partnerProfilesPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialLinksPropertyDefinition.name]: properties_1.socialLinksPropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.surnamePropertyDefinition.name]: properties_1.surnamePropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
        [properties_1.websitePropertyDefinition.name]: properties_1.websitePropertyDefinition,
    },
    roles: [],
    spaces: [
        'brand-building-events',
        'illume',
        'redbull_com',
    ],
    name: 'judge',
    localizations: [],
};
const isJudgeStencil = (stencil) => {
    return stencil.name === exports.judgeStencilDefinition.name;
};
exports.isJudgeStencil = isJudgeStencil;
//# sourceMappingURL=data:application/json;base64,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